import { Button } from "../components/Button";
import { PageFooterWrapper } from "../components/PageFooterWrapper";

interface RolesPageFooterProps {
  onAddRole: () => void;
}

export function RolesPageFooter(props: RolesPageFooterProps) {
  const { onAddRole } = props;

  return (
    <PageFooterWrapper>
      <Button fullWidth variant="contained" size="large" startIconType="plus" onClick={onAddRole}>
        Add new role
      </Button>
    </PageFooterWrapper>
  );
}
